import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-4K01ML8RPH";
let initialized = false;

export const canUseAnalytics = () =>
  typeof window !== "undefined" &&
  window.localStorage.getItem("cookiesAccepted") === "true";

export const initAnalytics = () => {
  if (!canUseAnalytics()) return false;
  if (initialized) return true;

  ReactGA.initialize(GA_MEASUREMENT_ID, { gtagOptions: { send_page_view: false } });
  // Preserve the existing GTM container, but load third-party tags after consent.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  const tag = document.createElement("script");
  tag.async = true;
  tag.src = "https://www.googletagmanager.com/gtm.js?id=GTM-NBBR6S26";
  document.head.appendChild(tag);
  initialized = true;
  return true;
};

export const trackPageView = (path) => {
  if (!initAnalytics()) return;

  ReactGA.send({
    hitType: "pageview",
    page: path,
    title: document.title,
  });
};

export const trackSeoEvent = (action, params = {}) => {
  if (!initAnalytics()) return;

  ReactGA.event(action, {
    category: "conversion",
    ...params,
  });
};
